import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BusinessHoursSelection from './BusinessHoursSelection';
import './styles.css';
import { connect } from 'react-redux';
import { fetchActiveHours, updateActiveHours } from '../../../state/actions/active-hours';
import Button from '../../../components/sitewide/Button'; // Adjusted import statement

const mapStateToProps = ({
  activeHours: {
    hours,
    isFetching,
    isUpdating,
  },
  account: {
    user: {activeLocation, locations}
  }
}) => ({
  hours,
  isFetching,
  isUpdating,
  activeLocation,
  locations
});

class WeeklyHours extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hours: props.hours, // Initialize state from props
      message: '',
      fetchedData: true, // State to track if data was fetched successfully
      hasChanges: false // State to track if there are unsaved changes
    };
  }

  componentDidMount() {
    this.fetchAndSetHours();
  }

  componentDidUpdate(prevProps) {
    const prevLocationId = prevProps.activeLocation ? prevProps.activeLocation.id : null;
    const currentLocationId = this.props.activeLocation ? this.props.activeLocation.id : null;

    if (prevLocationId !== currentLocationId) {
      this.fetchAndSetHours();
    }
  }

  fetchAndSetHours() {
    this.setState({ hours: [] });
    this.props.fetchActiveHours(this.props.activeLocation ? this.props.activeLocation.id : null)
      .then(() => {
        const activeLocationId = this.props.activeLocation ? this.props.activeLocation.id : null;
        const practiceId = this.props.activeLocation ? null : this.props.locations[0].practice_id;
        const ownerType = this.props.activeLocation ? "Location" : "Practice";

        if (this.props.hours.length === 0 && !this.state.hours.length) {
          this.setState({
            hours: Array.from({ length: 7 }, (_, index) => ({
              day_of_week: index,
              start_time: '1970-01-01T09:00:00.000Z',
              end_time: '1970-01-01T17:00:00.000Z',
              location_id: activeLocationId,
              owner_type: ownerType,
              practice_id: practiceId
            })),
            fetchedData: false, // Set to false if no data was fetched
            hasChanges: false // No changes initially
          });
        } else {
          this.setState({ hours: this.props.hours, fetchedData: true, hasChanges: false }); // Set to true if data was fetched
        }
      })
      .catch(() => {
        this.setState({ fetchedData: false }); // Set to false if fetch fails
      });
  }

  updateHour = (dayOfWeek, start_time, end_time) => {
    this.setState(prevState => ({
      hours: prevState.hours.map((hour, index) => {
        if (index === dayOfWeek) {
          return { ...hour, start_time, end_time };
        }
        return hour;
      }),
      hasChanges: true // Mark as changed
    }));
  }

  handleSave = () => {
    this.props.updateActiveHours(this.state.hours)
      .then(() => {
        this.fetchAndSetHours();
        this.setState({ message: 'Hours updated successfully!', hasChanges: false });
      })
      .catch(error => {
        this.setState({ message: 'Failed to update hours.' });
      });
  }

  render() {
    const { isFetching, isUpdating } = this.props;
    if (isFetching || isUpdating) {
      return <div>Loading...</div>;
    }

    const daysOfWeek = this.state.hours;
    const buttonLabel = !this.state.fetchedData ? 'Create New Hours' : (this.state.hasChanges ? 'Save Changes' : 'Saved');
    const isButtonActive = this.state.hasChanges || !this.state.fetchedData;

    return (
      <div>
        <h2>Weekly Hours</h2>
        <p>Select the hours that your business is open</p>
        <div className="weekly-hours__selection-container">
          {daysOfWeek.map((day) => (
            <BusinessHoursSelection
              key={day.id}
              dayOfWeek={day.day_of_week}
              hours={day}
              updateHour={this.updateHour}
            />
          ))}
        </div>
        <Button className="save-button" onClick={this.handleSave} disabled={!isButtonActive}>
          {buttonLabel}
        </Button>
        {this.state.message && <div>{this.state.message}</div>}
      </div>
    );
  }
}

WeeklyHours.propTypes = {
  fetchActiveHours: PropTypes.func.isRequired,
  updateActiveHours: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  fetchActiveHours,
  updateActiveHours
};

export default connect(mapStateToProps, mapDispatchToProps)(WeeklyHours);



// WEBPACK FOOTER //
// ./src/components/sitewide/WeeklyHours/index.js